@if (auditTrail) {
    <div>
        <app-code-highlight
            [code]="auditTrail.details | json"
            language="json"
        ></app-code-highlight>
    </div>
}
